import cx from "classnames";

import * as StateLib from "@/Utils/StateLib";
import {
  BuildViewLibraryOptionList,
  CanCreateTemplateWithName,
  CreateNewTemplate
} from "./ViewLibraryModal.util";
import { EditableList, Flex } from "@theorgchartdev/storybook";
import InputWithFloatingControls from "@/appComponents/Blocks/Composites/InputWithFloatingControls/InputWithFloatingControls";
import { enumChartTemplateSet } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

const AddNewViewListOption = props => {
  const handleSubmit = value => {
    CreateNewTemplate(value, props.set);
    props.manager.creatingState.setCreatingNew(false);
  };

  const handleCancel = () => {
    props.manager.creatingState.setCreatingNew(false);
  };

  const validatorFn = value => {
    // Empty Space check
    const trimmed = value.trim();
    if (trimmed.length < 2) return { result: false, msg: appstr("novalue"), status: "error" };

    // Avoid duplication
    if (!CanCreateTemplateWithName(trimmed))
      return { result: false, msg: appstr("nameinuse"), status: "error" };

    // All Good
    return { result: true, msg: "", status: "default" };
  };

  return (
    <div className="oc-view-library-tab-row" style={{ paddingTop: "12px", paddingBottom: "12px" }}>
      <InputWithFloatingControls
        dataTestId="view-library-add-view-name-input"
        autoFocus
        size="medium"
        inputOnly
        placeholder={appstr("View name")}
        align="right"
        saveOnBlur
        validatorFn={validatorFn}
        onConfirm={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
};

const getTargetKey = set => {
  if (set === enumChartTemplateSet.systemtemplates) {
    return "fSysTemplates";
  }

  if (set === enumChartTemplateSet.sharedtemplates) {
    return "fSharedTemplates";
  }

  return "fUserTemplates";
};

export const ViewLibraryTab = props => {
  const options = BuildViewLibraryOptionList(props.set, props.manager);

  if (props.manager.creatingState.isCreatingNew) {
    options.push({
      content: <AddNewViewListOption {...props} />,
      value: "new_value",
      divider: true,
      padding: false
    });
  }

  const handleShuffle = ids => {
    const wsMgr = StateLib.GetWSMgr();
    const ctm = wsMgr.GetChartTemplatesMgr();

    const targetKey = getTargetKey(props.set);
    const templates = ids.map(id => ctm.FindTemplateByID(id));
    ctm[targetKey] = templates;

    ctm.SetDirty();
    ctm.UpdateContext();
  };

  return (
    <Flex direction="column" height="100%">
      {props.actionNode}
      <div className={cx("ocn-file-manager-file-table", "ocn-list-scrollbar")}>
        <EditableList
          listWidth="fill"
          coloredSelection
          onSortValues={handleShuffle}
          disableSort={
            props.set === enumChartTemplateSet.systemtemplates ||
            props.manager.creatingState.isCreatingNew ||
            props.manager.editingState.editingIds.size > 0
          }
          options={options}
          /*
           * `options` is being built external from React's lifecycle
           * This dummy fn does nothing to update the state
           * Instead, `onSortValues` is used to update the state
           */
          setOptions={dispatch => dispatch(options)}
          value={props.manager.selectedTemplateState.selectedId}
        />
      </div>
    </Flex>
  );
};
